"use strict";

exports.__esModule = true;
exports.normalizePhoneNumber = exports.normalizeNumericWithSpaces = exports.normalizeNumber = exports.normalizeNoSpaces = exports.normalizeName = exports.normalizeInviteCode = exports.normalizeDate = exports.normalizeAlphaNumericWithSpaces = exports.normalizeAlphaNumeric = void 0;

/**
 * Normalisation helper functions for redux-form
 * @param {*} value - the new value of the field
 * @param {*} previousValue - the previous value of the field
 */
// Method to allow only numbers
const normalizeNumber = (value, previousValue) => !value ? value : value.replace(/[^\d]/g, '');

exports.normalizeNumber = normalizeNumber;

const normalizeNumericWithSpaces = (value, previousValue) => !value ? value : value.replace(/[^\d\s]/g, '');

exports.normalizeNumericWithSpaces = normalizeNumericWithSpaces;

const normalizeAlphaNumeric = (value, previousValue) => !value ? value : value.toUpperCase().replace(/[^\dA-Za-z]/g, '');

exports.normalizeAlphaNumeric = normalizeAlphaNumeric;

const normalizeAlphaNumericWithSpaces = (value, previousValue) => !value ? value : value.toUpperCase().replace(/[^\dA-Za-z\s]/g, '');

exports.normalizeAlphaNumericWithSpaces = normalizeAlphaNumericWithSpaces;

const normalizeName = (value, previousValue) => !value ? value : value.replace(/[^A-Za-z'\-\s]/g, '');

exports.normalizeName = normalizeName;

const normalizeNoSpaces = (value, previousValue) => !value ? value : value.replace(/[\s]/g, '');

exports.normalizeNoSpaces = normalizeNoSpaces;

const normalizeInviteCode = (value, previousValue) => {
  if (!value) {
    return value;
  } // Remove non-alpha and digit characters


  let newValue = value.toUpperCase().replace(/[^\dA-Z]/g, ''); // Limit the invite code to 10 characters

  if (newValue.length > 10) {
    newValue = newValue.substring(0, 10);
  } // if the hyphen has been deleted then remove the 5th character of the invite code


  if (/^[\dA-Z]{5}\s-?$/.test(value)) {
    newValue = newValue.substring(0, 4);
  } // Insert a hyphen after the first 5 characters


  if (newValue.length >= 5) {
    newValue = newValue.substring(0, 5) + ' - ' + newValue.substring(5);
  }

  return newValue;
};

exports.normalizeInviteCode = normalizeInviteCode;

const normalizeDate = (value, previousValue) => {
  if (!value) {
    return value;
  } // Remove non-numeric characters and replace consecutive slashes with a single slash


  value = value.replace(/[^\d/]/g, ''); // replace consecutive slashes unless they are in the middle of the date while editing

  if (!/\d+\/{2,}\d+$/.test()) {
    value = value.replace(/\/{2,}$/g, '/');
  } // Don't allow more than two slashes in a date


  if (value.split('/').length > 3) {
    return previousValue;
  } // Don't allow a forward slash at the start of a date


  if (/^\/$/.test(value)) {
    return '';
  } // Prefix days and months with zero


  if (/^\d{1,2}\/\d\/$/.test(value)) {
    const daysAndMonths = value.split('/');
    return `${('0' + daysAndMonths[0]).slice(-2)}/${('0' + daysAndMonths[1]).slice(-2)}/`;
  } // Prefix days with zero


  if (/^\d\/$/.test(value)) {
    return `0${value}`;
  } // Automatically add a slash after the days are entered


  if (/^\d$/.test(previousValue) && /^\d{2}$/.test(value)) {
    return `${value}/`;
  } // Automatically add a slash after the months are entered


  if (/^\d{2}\/\d$/.test(previousValue) && /^\d{2}\/\d{2}$/.test(value)) {
    return `${value}/`;
  } // Insert a slash if three or four digits are entered for the days


  if (/^\d{3}$/.test(value)) {
    return `${value.substring(0, 2)}/${value.substring(2)}`;
  } // Insert two slashes if four or more digits are entered for the days


  if (/^\d{4,8}$/.test(value)) {
    return `${value.substring(0, 2)}/${value.substring(2, 4)}/${value.substring(4)}`;
  } // Insert a slash if three digits are entered for the months


  if (/^\d{2}\/\d{3}$/.test(value)) {
    return `${value.substring(0, 2)}/${value.substring(3, 5)}/${value.substring(5, 8)}`;
  } // Don't allow more than two digits to be inserted into the days field


  if (/^\d{3,}\/\d{2}\/\d{0,4}$/.test(value)) {
    return previousValue;
  } // Don't allow more than two digits to be inserted into the months field


  if (/^\d{2}\/\d{3,}\/\d{0,4}$/.test(value)) {
    return previousValue;
  } // Don't allow more than four digits to be inserted into the years field


  if (/^\d{0,2}\/\d{0,2}\/\d{5,}$/.test(value)) {
    return previousValue;
  }

  return value;
};

exports.normalizeDate = normalizeDate;

const normalizePhoneNumber = (value, previousValue) => {
  if (!value) {
    return value;
  } // Only allow numbers, spaces and plus symbols in the field


  value = value.replace(/[^\d\s+]/g, ''); // Only allow a single plus symbol at the start of the phone number

  const parts = value.split('+');

  if (parts.length > 1) {
    value = parts[0].trim().length === 0 ? `+${parts[1].trimStart()}` : parts[0];
  }

  return value;
};

exports.normalizePhoneNumber = normalizePhoneNumber;